import React, { useState, useRef, useContext } from 'react'
import { Dimensions, ScrollView, StyleSheet, Image, Text, View } from 'react-native';
import { AiOutlineDoubleLeft, AiOutlineDoubleRight } from "react-icons/ai";

import { contentWrapColor } from '../../../../../style/css/CmnStyle';
import { hpContext } from '../../../HPContext';
import FunctionItem1 from './item/FunctionItem1';
import FunctionItem2 from './item/FunctionItem2';
import FunctionItem3 from './item/FunctionItem3';
import FunctionItem4 from './item/FunctionItem4';


function HpContentFunction(props) {
  const isWide = useContext(hpContext).isWide;

  const styles = StyleSheet.create({
    container: {
      backgroundColor: contentWrapColor,
    },
  });



  return (
    <View id='functions' style={styles.container}>
      <FunctionItem1 />
      <FunctionItem2 />
      <FunctionItem3 />
      <FunctionItem4 />
    </View>
  );
}

export default HpContentFunction;
